import { render, staticRenderFns } from "./ListAssinaturas.vue?vue&type=template&id=84a72928&"
import script from "./ListAssinaturas.vue?vue&type=script&lang=js&"
export * from "./ListAssinaturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports